import ReportPieChart from "./ReportPieChart.vue";

export default ReportPieChart;
